import React from 'react';
import { CampusUserWithApplication, UserSkillRatingDocument } from 'types';
import { badgesList } from 'src/components/profile/ProfileTechnicalScorecard';
import { isScoreRangeValid } from 'shared-utils';
import { Tooltip } from '@mui/material';

const CandidateSkills = ({ skillRatings = [] }: { skillRatings: UserSkillRatingDocument[] }) => {
	const getBadgesWithSkills = (skillRatings: UserSkillRatingDocument[]) => {
		const badgesWithSkills = badgesList.map(badge => {
			const filteredSkills = (skillRatings?.length ? skillRatings || [] : []).filter(item => {
				const score = isScoreRangeValid(Math.round(item.rating));
				return score >= badge.minScore && score < badge.maxScore;
			});
			return { ...badge, skills: filteredSkills };
		});

		// Sort badges by the number of skills, descending
		return badgesWithSkills
			.sort((a, b) => b.minScore - a.minScore)
			?.filter(el => el.skills.length)
			.slice(0, 2);
	};
	const badeges = getBadgesWithSkills(skillRatings);

	if (!badeges?.length) return <div>NA</div>;
	return (
		<div className="flex justify-center gap-[18px] text-center mx-auto">
			{badeges?.map((badege, index) => (
				<div key={index} className="flex flex-col">
					<div
						className="flex items-center gap-1 rounded-[6px] px-3 py-[2px]"
						style={{ background: badege?.bg, color: badege?.text }}
					>
						<img src={badege?.icon} alt="" className="max-w-[20px] max-h-[20px]" />
						{badege?.title}
					</div>
					{badege?.skills?.length ? (
						<Tooltip
							title={<div className="text-center">{badege?.skills?.map(skill => skill?.skill?.name)?.join(', ')}</div>}
							arrow
							placement="bottom"
						>
							<div className="flex justify-center border-b border-[#555770] mx-auto border-dashed w-fit text-center mt-1 text-sm font-[500] text-[#555770]">
								{badege?.skills?.length ? `${badege?.skills?.length} skills` : ''}
							</div>
						</Tooltip>
					) : null}
				</div>
			))}
		</div>
	);
};

export default CandidateSkills;
